import {BaseService} from '@esgi/core/service';
import {TestPreviewModel} from './models';

export class PreviewService extends BaseService {
	public init(testID: number) {
		return this.httpClient.ESGIApi.get<TestPreviewModel>('assets/tests', 'preview', {testID});
	}
}
